
<template>
    <section v-loading.fullscreen.lock="allLoadLoading">
        <!-- <el-button type="warning" v-if="IsInput!=''" @click="back" plain icon="el-icon-back">返回</el-button> -->
        <el-row>
            <el-col :span="16">
                <div class="grid-content bg-purple" style="margin-top: 10px;color: #495060;">
                    <span><el-tag type="success" v-if="this.assessmentFile.Id != ''">{{ this.assessmentFile.HospitalName
                            }}</el-tag></span> <span style="margin-left: 10px;">档案号：<el-tag type="success"
                            v-if="this.assessmentFile.Id != ''">{{ this.assessmentFile.Number
                            }}</el-tag></span>
                    <!-- <span style="margin-left: 10px;">负责人：
                                <el-tag
                            type="success" v-if="this.assessmentFile.Id!=''&&this.assessmentFile.ScoreUserName!=null">{{ this.assessmentFile.ScoreUserName }}
                        </el-tag> 
                        </span> -->
                    <!-- <transition name="el-zoom-in-top">
                        <label >
                            <span style="margin-left: 100px">分数：</span>
                                <count-to style="font-family: 微软雅黑;font-size: 25px;color: #E6A23C;" :start-val="0" :end-val="this.assessmentFile.Score" :decimals="1" :duration="2600" class="card-panel-num" />
                        </label>
                    </transition> -->
                </div>
            </el-col>
            <el-col :span="8">

                <div class="grid-content bg-purple"
                    style="float: right;margin-top: 10px;margin-right: 10px;color: #495060;">
                    <el-divider direction="vertical"></el-divider>
                    <!-- <span>评级状态：</span><el-tag type="warning" v-if="this.assessmentFile.State == '1'">未提交</el-tag> -->
                    <!-- <el-tag type="success" v-if="this.assessmentFile.State == '2'">已提交</el-tag>
                    <el-tag type="info" v-if="this.assessmentFile.State == '3'">未通过</el-tag>
                    <el-tag type="success" v-if="this.assessmentFile.State == '4'">已通过</el-tag>
                    <el-tag type="success" v-if="this.assessmentFile.State == '5'">已考核</el-tag>
                    <el-tag type="success" v-if="this.assessmentFile.State == '6'">已归档</el-tag> -->
                </div>
            </el-col>
        </el-row>
        <el-divider></el-divider>
        <el-row>
            <el-col :span="32">
                <div class="grid-content bg-purple">
                    <el-input prefix-icon="el-icon-search" v-model="input" style="width: 300px;"
                        placeholder="请输入标准序号、评审模块、标准概述" @keyup.enter.native="handleQuery"></el-input>
                    <el-button type="primary" style="margin-left: 20px;"
                        v-if="!IsEnableBtn && this.IsInput === '' && (this.assessmentFile.State != 2 && this.assessmentFile.State != 4)"
                        @click="overallUploadClick">整体上传</el-button>
                    <el-button @click="check" type="primary" plain style="margin-left: 20px;"
                        v-if="!IsEnableBtn && this.IsInput === '' && (this.assessmentFile.State != 2 && this.assessmentFile.State != 4)">检查</el-button>
                    <!-- <el-button @click="submit"  type="primary" plain v-if="!IsEnableBtn&&this.assessmentFile.State==1">提交</el-button> -->
                    <!-- <el-button type="warning" @click="build"
                        v-if="!IsEnableBtn && this.assessmentFile.Id == '' && this.IsInput === ''">生成考核档案</el-button> -->
                    <el-select v-model="checkValue" placeholder="请选择" @change="checkDataChoose"
                        style="margin-left: 20px;">
                        <el-option v-for="item in checkData" :key="item.Id" :label="item.Name" :value="item.Id">
                        </el-option>
                    </el-select>
                    <!-- <el-button type="primary" style="margin-left: 20px;" v-if="IsInput!=''&&this.assessmentFile.State>1&&this.assessmentFile.State!=4" @click="audit">审核</el-button>
                    <el-select v-model="assessmentFileState"  style="margin-left: 20px;"  placeholder="请选择审核是否通过" v-if="IsInput!=''&&this.assessmentFile.State>1&&this.assessmentFile.State!=4">
                        <el-option label="审核通过" :value=4></el-option>
                        <el-option label="审核不通过" :value=3></el-option>
                    </el-select>
                    <transition name="el-zoom-in-center">
                        <el-input v-model="reason" placeholder="请输入理由" ref="reasonInput" @focus="writeReason" style="width: 250px;margin-left: 20px;" v-if="IsInput!=''&&assessmentFileState==3"></el-input>

                    </transition>
                    <el-drawer
                            title="请输入理由"
                            :visible.sync="drawer"
                            direction="ttb"
                            :before-close="drawerHandleClose" size="50%">
                            <el-input
                            type="textarea"
                            placeholder="请输入内容"
                            :rows="5"
                            v-model="reason"
                            maxlength="500"
                            show-word-limit
                            >
                            </el-input>
                        </el-drawer> -->
                </div>
            </el-col>
        </el-row>
        <div style="margin-top: 20px;">
            <el-table :data="tableData" border style="width: 100%">
                <el-table-column prop="Level" label="重要程度" width="80" :show-overflow-tooltip="true">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.Level === 1" effect="dark" type="success">低</el-tag>
                        <el-tag v-if="scope.row.Level === 2" effect="dark" type="warning">中</el-tag>
                        <el-tag v-if="scope.row.Level === 3" effect="dark" type="danger">高</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="IsStandards" label="是否达标" width="80" :show-overflow-tooltip="true">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.IsStandards === true" effect="dark" type="success">已达标</el-tag>
                        <el-tag v-if="scope.row.IsStandards === false" effect="dark" type="warning">未达标</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="StIndex" label="标准序号" width="100" :show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column prop="ReviewContent" label="评审模块" width="250" :show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column prop="Stoverview" label="标准概述" width="250" :show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column prop="Stscore" label="标准分值" width="80" :show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column prop="PersonLiableName" label="责任人" width="80" :show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column prop="Zrbm" label="责任部门" width="150" :show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column prop="Xzbm" label="协助部门" width="150" :show-overflow-tooltip="true">
                </el-table-column>
                <!-- <el-table-column prop="State" label="评级状态" width="80" :show-overflow-tooltip="true">
                        <template slot-scope="scope">
                            <el-tag v-if="scope.row.State === 1" effect="dark" type="info">未提交</el-tag>
                            <el-tag v-if="scope.row.State === 2" effect="dark" type="success">已提交</el-tag>
                            <el-tag v-if="scope.row.State === 3" effect="dark" >未通过</el-tag>
                            <el-tag v-if="scope.row.State === 4" effect="dark" type="warning">已通过</el-tag>
                            <el-tag v-if="scope.row.State === 5" effect="dark" type="danger">已考核</el-tag>
                            <el-tag v-if="scope.row.State === 6" effect="dark" type="success">已归档</el-tag>
                        </template>
                </el-table-column> -->
                <el-table-column prop="SubmitState" label="状态" width="100" :show-overflow-tooltip="true">
                    <template slot-scope="scope">
                        <span v-if="scope.row.SubmitState === 1">已提交</span>
                        <span v-if="scope.row.SubmitState === 2">未提交</span>
                        <span v-if="scope.row.SubmitState === 3">审核通过</span>
                        <span v-if="scope.row.SubmitState === 4">审核未通过</span>
                    </template>
                </el-table-column>
                <el-table-column prop="ReviewTime" label="评审时间" width="100" :show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column prop="Score" label="得分" width="100" :show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column fixed="right" label="操作">
                    <template slot-scope="scope">
                        <el-button @click="handleClickDetail(scope.row)" type="text" size="small">查看详情</el-button>
                        <el-button @click="deductReason(scope.row)" type="text" size="small">扣分原因</el-button>
                        <el-button
                            v-if="fileValue == '' && IsInput == '' && (scope.row.SubmitState == null || scope.row.SubmitState == 2 || scope.row.SubmitState == 4)"
                            @click="submitModule(scope.row)" type="text" size="small">提交</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <!--工具条-->
        <el-col :span="24" class="toolbar">
            <el-pagination layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="pageSize"
                :total="total" style="float: right"></el-pagination>
        </el-col>
        <!--查看详情页面-->
        <el-dialog :title="detailTitle" :visible.sync="editFormVisible" v-model="editFormVisible"
            :close-on-click-modal="false" :before-close="handleClose" width="100%" :append-to-body="IsEnableBtn">
            <div style="float: left;margin-bottom: 10px;">
                <el-alert v-if="this.IsInput != '' && !this.IsScoring" title="该考核模块未提交，考核机构不能打分以及操作保存数据功能！！！"
                    type="warning" center :closable="false" show-icon>
                </el-alert>
            </div>
            <div style="float: right;margin-bottom: 10px;">

                <el-button type="success" style="margin-left: 20px;" @click="calculate(3)"
                    v-if="this.IsInput != '' && this.SubmitState != 3" v-loading.fullscreen.lock="fullscreenLoading"
                    element-loading-text="正在审核中...">审核通过</el-button>
                <el-button type="warning" style="margin-left: 20px;" @click="calculate(4)"
                    v-if="this.IsInput != '' && this.SubmitState != 4" v-loading.fullscreen.lock="fullscreenLoading"
                    element-loading-text="正在审核中...">审核驳回</el-button>
                <el-button type="primary" style="margin-left: 20px;" @click="calculate(null)" v-if="this.IsInput != ''"
                    v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="正在保存中...">暂存</el-button>
            </div>
            <div>

                <el-table :data="detailData" :span-method="spanMethod" border style="width:100%"
                    v-loading="detailDataLoading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading"
                    element-loading-background="rgba(0, 0, 0, 0.8)" @cell-dblclick="cellClick">
                    <el-table-column prop="PStIndex" width="100" label="标准序号" align="center"
                        :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column prop="ReviewPoints" width="250" label="评审要点" align="center"
                        :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column prop="ReviewMethod" width="300" label="评审方法" align="center"
                        :show-overflow-tooltip="true"></el-table-column>
                    <!-- <el-table-column prop="bzfz" width="100" label="标准分值" align="center"
                        :show-overflow-tooltip="true"></el-table-column> -->
                    <el-table-column prop="Xzbm" width="180" label="协助部门" align="center"
                        :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column prop="Zrbm" width="150" label="责任部门" align="center"
                        :show-overflow-tooltip="true"></el-table-column>
                    <!-- <el-table-column prop="Stscore" width="80" label="标准分值" align="center"
                        :show-overflow-tooltip="true"></el-table-column> -->
                    <el-table-column prop="CheckUserName" width="80" label="自查人" align="center"
                        :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column prop="Ischeck" width="100" label="状态" align="center" :show-overflow-tooltip="true">
                        <template slot-scope="scope">
                            <el-tag v-if="scope.row.Ischeck === true" effect="dark" type="success">已自查</el-tag>
                            <el-tag v-if="scope.row.Ischeck === false" effect="dark" type="info">未自查</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column prop="Score" width="75" label="扣分" align="center">
                        <template slot-scope="scope">
                            <el-input v-if="scope.row.$isScoreEdit && scope.row.ItemId != null && SubmitState != 3"
                                v-model="scope.row.Score"
                                onkeyup="value=value.replace(/^(\-)*(\d+)\.(\d\d).*$/,'$1$2.$3').replace(/[^\d.]/g,'')"
                                @keyup.enter.native="editScore(scope.row)" @blur="editScore(scope.row)" />
                            <span v-else>
                                {{ scope.row.Score }}
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="Remark" width="260" label="备注" align="center"
                        :show-overflow-tooltip="IsShowText">
                        <template slot-scope="scope">
                            <el-input type="textarea" :rows="5"
                                v-if="scope.row.$isRemarkEdit && scope.row.ItemId != null && SubmitState != 3"
                                v-model="scope.row.Remark" @keyup.enter.native="editRemark(scope.row)"
                                @blur="editRemark(scope.row)" />
                            <span v-else>
                                {{ scope.row.Remark }}
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="FileCount" :resizable="false" width="100" label="文件个数" align="center"
                        :show-overflow-tooltip="true">
                        <template slot-scope="scope">
                            <el-button @click="lookDocu(scope.row)" type="text" size="medium">{{ scope.row.FileCount
                                }}</el-button>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <el-button @click="uploadFile(scope.row)" size="small" type="text"
                                v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="文件上传中,请耐心等待...."
                                v-if="!IsEnableBtn && scope.row.isShowBtn && scope.row.ItemId != null && (scope.row.SubmitState != 3)&&submitStatus">上传</el-button>
                            <el-button @click="downFileTemplate(scope.row)" type="text" size="small"
                                v-if="scope.row.CheckDetailId != 0">下载模板</el-button>
                            <el-button @click="lookDocu(scope.row)" type="text" size="small"
                                v-if="scope.row.ItemId != null">查看文档</el-button>
                            <el-button @click="handleClick(scope.row)" type="text" size="small"
                                v-if="!IsEnableBtn && scope.row.Ischeck != null && scope.row.isShowBtn && scope.row.ItemId != null && (scope.row.SubmitState != 3)&&submitStatus">自查</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <el-upload ref="upload" v-show="false" :action="fileAdress" :limit="1" :on-success="uploadSuccess"
                    :before-upload="beforeupload" :on-change="handleChange" :on-error="uploadError"
                    :data="{ 'ItemId': itemId }" :headers="myHeaders" :auto-upload="false">
                    <el-button size="small" type="text">点击上传</el-button>
                </el-upload>
            </div>
        </el-dialog>
        <!--文件模板下载-->
        <el-dialog title="文件模板" v-if="fileTemplateVisible" :visible.sync="fileTemplateVisible"
            v-model="fileTemplateVisible" width="80%" :close-on-click-modal="false"
            :before-close="overallUploadHandleClose" :destroy-on-close="true" :append-to-body="IsEnableBtn">
            <el-table :data="temples" border v-loading="listLoading" ref="table" class="custom-tbl" style="width: 100%">
                <el-table-column prop="FileName" label="文件名" width="350px"></el-table-column>
                <el-table-column prop="Path" label="文件路径" width="350px"></el-table-column>
                <el-table-column prop="Format" label="文件格式" width=""></el-table-column>
                <el-table-column prop="FileVersion" label="文件版本号" width=""></el-table-column>
                <el-table-column prop="Remark" label="备注" width=""></el-table-column>
                <el-table-column prop="CreateTime" label="上传时间" width=""></el-table-column>
                <el-table-column prop="CreateBy" label="上传人" width=""></el-table-column>
                <el-table-column fixed="right" label="操作" width="200">
                    <template slot-scope="scope">
                        <el-button @click="downTemplate(scope.row)" type="text" size="small">下载</el-button>
                    </template>
                </el-table-column>
            </el-table>

            <!-- 分页 -->
            <el-pagination class="toolbar" @size-change="templateHandleSizeChange"
                @current-change="templateHandleCurrentChange" :current-page="templatePage" :page-size="templatePageSize"
                :page-sizes="[50, 100, 200]" layout="total, sizes, prev, pager, next, jumper" :total="templaetTotal">

            </el-pagination>

        </el-dialog>
        <!--检查未自查的考核细项-->
        <el-dialog title="检查未自查的考核细项" :visible.sync="checkVisible" v-model="checkVisible" :close-on-click-modal="false"
            :before-close="checkHandleClose" width="80%" :destroy-on-close="true" :append-to-body="IsEnableBtn">
            <div class="infinite-list-wrapper" style="height: 50vh;overflow-y: auto;">
                <!-- <ul
                class="list"
                v-infinite-scroll="load"
                infinite-scroll-disabled="disabled">
                <li v-for="i in count" class="list-item">{{ i }}</li>
                </ul> -->
                <div>
                    <div v-for="(i, index) in notCheckData" :key="index" style="margin-top: 10px;">
                        <el-alert :title="i.ModleName + '  (未自查)'" type="warning" :closable="false"
                            :description="i.ReviewMethod" show-icon>
                        </el-alert>
                    </div>
                </div>
            </div>
        </el-dialog>
        <!--扣分原因-->
        <el-dialog title="扣分原因" :visible.sync="deductReasonVisible" v-model="deductReasonVisible"
            :close-on-click-modal="false" :before-close="deductReasonHandleClose" width="80%" :destroy-on-close="true"
            :append-to-body="IsEnableBtn">
            <div class="infinite-list-wrapper" style="height: 50vh;overflow-y: auto;">
                <!-- <ul
                class="list"
                v-infinite-scroll="load"
                infinite-scroll-disabled="disabled">
                <li v-for="i in count" class="list-item">{{ i }}</li>
                </ul> -->
                <div>
                    <template v-if="deductReasonData.length != 0">
                        <div v-for="(i, index) in deductReasonData" :key="index" style="margin-top: 10px;">
                            <el-alert :title="i.ReviewMethod + '  (考核细项)'" type="warning" :closable="false"
                                :description="i.Remark" show-icon>
                            </el-alert>
                        </div>
                    </template>

                    <div v-if="deductReasonData.length == 0" style="text-align: center;">暂无数据</div>
                </div>
            </div>
        </el-dialog>
        <!--查看文档-->
        <el-dialog title="预览文档" v-if="lookDocumentVisible" :visible.sync="lookDocumentVisible"
            v-model="lookDocumentVisible" width="80%" :close-on-click-modal="false"
            :before-close="lookDocumentHandleClose" :destroy-on-close="true" :fullscreen="true"
            :append-to-body="IsEnableBtn">
            <LookDocument :itemId="itemId" :IsEnableLookFile="IsEnableLookFile"></LookDocument>
        </el-dialog>
        <!--整体上传-->
        <el-dialog title="整体上传" v-if="overallUploadVisible" :visible.sync="overallUploadVisible"
            v-model="overallUploadVisible" width="80%" :close-on-click-modal="false"
            :before-close="overallUploadHandleClose" :destroy-on-close="true" :append-to-body="IsEnableBtn">
            <OverallUpload @closeDialog="overallUploadVisible = false"></OverallUpload>
        </el-dialog>
        <!-- <div class="loading-overlay" v-if="loadingVisible">
            <el-progress type="circle" :percentage="loadingPercentage" :stroke-width="6" ></el-progress>
            <p class="tips_css">升级中，请稍后！</p>
        </div> -->
    </section>
</template>
<script>
import LookDocument from './../../components/LookDocument.vue';
import OverallUpload from '../EvaluationAgency/OverallUpload.vue';
import {
    getAssessmentFile,
    getEvaluationAgencyList,
    GetUpdateStatus,
    getDetailItemPassMoudleId,
    postSelectNotCheck,
    generateAssessment,
    postCalculateScore,
    postExamine,
    getUpdateCheck, DownFiles, postSelectDeductReason,
    getUpdateModuleState, DownFiletemplate
} from "../../api/EvaluationAgency/EvaluationAgency";
import {
    GetCheck, GetFiletemplatesPage
} from "../../api/RatingManage/RatingManage";
import * as api from '../../api/api';
import { Loading } from 'element-ui';
import CountTo from 'vue-count-to'
export default {
    components: { LookDocument, OverallUpload, CountTo },
    props: ["ratingData", "checkpValue", "fileManagermentPassId", "checkDatas", "fileState"],
    data() {
        return {
            //#region  文件模板下载功能所有参数
            temples: [],
            listLoading: false,
            checkDetailId: "",
            templaetTotal: 0,
            templatePage: 1,
            templatePageSize: 50,
            //#endregion

            drawer: false,
            detailDataLoading: false,
            deductReasonData: [],
            deductReasonVisible: false,
            IsEnableLookFile: true,
            allLoadLoading: false,
            fileAdress: api.BaseApiUrl + "/api/AssessmentBusiness/PostUploadFile",
            overallUploadVisible: false,//整体上传弹出框显示
            fileTemplateVisible: false,//文件模板下载
            show3: false,
            reason: "",
            assessmentFileState: "",//档案审核状态
            loadingPercentage: 0,//进度百分比
            timer: null,//定时器
            loadingVisible: false,//开启遮罩
            fullscreenLoading: false,//上传文件loding
            myHeaders: null,
            IsInput: "",//考核机构传进来的值
            fileManagermentFileId: null,//档案管理界面传的档案ID
            IsEnableBtn: false,//是否禁用所有按钮功能（针对档案管理界面跳转过来的）
            IsHavaCheckId: "",
            score: "",
            IsShowText: true,
            editFormVisible: false,
            checkVisible: false,
            lookDocumentVisible: false,
            input: "",
            total: 0,
            pageSize: 10,
            //考核档案数据
            assessmentFile: {
                HospitalName: "",
                Number: "",
                Id: "",
                State: "",
                ScoreUserName: ""
            },
            itemId: "",
            pageIndex: 1,
            tableData: [],
            detailData: [],
            loading: false,
            isInfiniteScrollDisabled: false,
            notCheckData: [],
            hospitalId: "",
            checkData: [],
            checkValue: "",
            SubmitState: "",
            detailTitle: "院内考核",
            fileValue: "",//档案状态传的值  档案状态
            IsScoring: true,//定义是否可以打分，
            fileCount: 0,//定义全局变量 控制文件上传
            moduleId: null,//记录模块Id  做刷新效果
            submitStatus:true
        }
    },
    computed: {
    },
    mounted() {
    },
    watch: {
        checkValue(newValue, oldValue) {
            if (this.IsHavaCheckId != "") {
                this.checkDataChoose(newValue);
            }
        },
    },
    created() {
        this.filterLoadValue();
    },
    methods: {
        //#region  文件模板下载功能
        downTemplate(row) {
            DownFiletemplate(row.Id).then((res) => {
                if (res && res.data) {
                    // 创建Blob对象
                    const blob = new Blob([res.data], { type: 'application/octet-stream' });
                    // 创建一个链接元素
                    const url = window.URL.createObjectURL(blob);
                    const link = document.createElement('a');
                    link.href = url;
                    // 从响应头中获取文件名
                    const contentDisposition = res.headers['content-disposition'];
                    let fileName = 'downloaded-file';
                    if (contentDisposition) {
                        const matches = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(contentDisposition);
                        if (matches != null && matches[1]) {
                            fileName = decodeURIComponent(matches[1].replace(/['"]/g, ''));
                        }
                    }
                    // 检查是否支持msSaveOrOpenBlob方法
                    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                        // Edge特定的文件下载方法
                        window.navigator.msSaveOrOpenBlob(blob, fileName);
                    } else {
                        // 创建一个链接元素
                        const url = window.URL.createObjectURL(blob);
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', fileName);
                        // 触发下载
                        document.body.appendChild(link);
                        link.click();
                        // 移除链接元素
                        document.body.removeChild(link);
                        // 释放URL对象
                        window.URL.revokeObjectURL(url);
                    }
                }
            })
                .catch((error) => {
                    console.error('下载文件失败:', error);

                });
        },
        gettemplates() {
            let para = {
                page: this.templatePage,
                PageSize: this.templatePageSize,
                CheckDetailId: this.CheckDetailId
            };
            this.listLoading = true;
            GetFiletemplatesPage(para).then((res) => {
                this.templaetTotal = res.data.response.dataCount;
                this.temples = res.data.response.data;
                this.listLoading = false;
            });
        },
        templateHandleCurrentChange(val) {
            this.templatePage = val;
            this.gettemplates();
        },
        templateHandleSizeChange(size) {
            this.templatePageSize = size;
            this.templatePage = 1; // 当更改分页大小时，重置为第一页
            this.gettemplates();

        },
        filterLoadValue() {
            if (this.fileState != undefined && this.fileState != "") {
                this.fileValue = this.fileState;
            }
            if (this.ratingData != undefined && this.ratingData != "") {
                this.IsInput = this.ratingData;
                this.detailTitle = "院内评审";
                this.hospitalId = this.IsInput;
                this.IsHavaCheckId = this.checkpValue;
                this.checkValue = this.checkpValue;
                //判断考核机构传来的数组(考核表)是否不存在
                if (this.checkDatas != undefined && this.checkDatas != "") {
                    this.checkData = this.checkDatas;
                }
            }
            else {
                if (this.fileManagermentPassId != undefined && this.fileManagermentPassId != "") {
                    this.fileManagermentFileId = this.fileManagermentPassId;
                    this.IsEnableBtn = true;
                }
                this.hospitalId = this.$store.state.hospitalId;
                this.loadApiData();
            }


            let params=this.$store.state.publicParams;
            if (params.length!=0) {
                let paramsData=params.find(item=>item.Name=="Submit_Status");
                if (paramsData!=undefined) {
                    if (paramsData.Value=="1") {
                        this.submitStatus=true;
                    }
                    else
                    {
                        this.submitStatus=false;
                    }
                }
            }
        },
        downFileTemplate(row) {
            this.CheckDetailId = row.CheckDetailId;
            this.fileTemplateVisible = true;
            this.gettemplates();
        },
        //#endregion


        submitModule(row) {
            let msg = row.SubmitState == null || row.SubmitState == 2 ? '是否提交?' : '是否取消提交';
            this.$confirm(msg, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                let parms = { id: row.Id };
                getUpdateModuleState(parms).then((res) => {
                    if (res.success) {
                        this.$message({
                            type: 'success',
                            message: '提交成功!'
                        });
                        this.handleQuery();
                    }
                    else {
                        this.$message({
                            type: 'error',
                            message: '提交失败!'
                        });
                    }
                });
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消提交'
                });
            });
        },
        async loadApiData() {
            //获取考核表
            await this.GetCheckData();
            //加载考核档案数据
            await this.loadAssessmentFile();
        },
        //获取考核表
        async GetCheckData() {
            let para = {
                page: 1,
                key: "",
                pageSize: 1000,
            };
            await GetCheck(para).then((res) => {
                console.log(res.data);
                if (res.data.success) {
                    this.checkData = res.data.response.data;

                    if (sessionStorage.getItem('checkId') != null) {
                        this.checkValue = sessionStorage.getItem('checkId');
                    } else {
                        if (this.checkData.length > 0) {
                            this.checkValue = this.checkData[0].Id;
                        }
                    }
                }
            });
        },
        //整体上传
        overallUploadClick() {
            this.overallUploadVisible = true;
        },
        drawerHandleClose(done) {
            console.log(this.$refs.reasonInput);
            this.$refs.reasonInput.blur();
            done();
        },
        writeReason() {
            this.drawer = true;
            this.$refs.reasonInput.blur();
        },
        back() {
            this.$emit('onEmitIndex', true)
        },
        //自查
        handleClick(row) {
            getUpdateCheck({ Id: row.Id }).then((res) => {
                if (res.success) {
                    this.$message({
                        message: res.msg,
                        type: 'success'
                    });
                }
                this.loadDetailData();
            })
        },
        //审核
        audit() {
            if (this.assessmentFileState == "") {
                this.$message({
                    message: '请选择审核状态!',
                    type: 'warning'
                });
                return
            } else if (this.assessmentFileState == 3 && this.reason == "") {
                this.$message({
                    message: '请输入理由!',
                    type: 'warning'
                });
                return
            }
            postExamine({ Id: this.assessmentFile.Id, State: this.assessmentFileState, Reason: this.reason }).then((res) => {
                if (res.response) {
                    this.$message({
                        message: '审核成功!',
                        type: 'success'
                    });
                    //加载考核档案数据
                    this.loadAssessmentFile();
                }
            });
        },
        startLoading() {
            this.loadingVisible = true;
            this.loadingPercentage = 0;

            this.timer = setInterval(() => {
                if (this.loadingPercentage < 100) {
                    this.loadingPercentage += 1;
                } else {
                    clearInterval(this.timer); // 停止计时器

                    // 延时 1 秒后执行关闭遮罩或其他操作
                    setTimeout(() => {
                        this.loadingVisible = false;
                        // 关闭遮罩或执行其他操作
                    }, 1000);
                }
            }, 900); // 每 900 毫秒（0.9秒）增加 1% 进度
        },
        lookDocumentHandleClose(done) {
            this.IsEnableLookFile = true;
            done();
        },
        overallUploadHandleClose(done) {
            done();
        },
        loadDetailData() {
            getDetailItemPassMoudleId({ id: this.moduleId }).then((res) => {
                if (res.success) {
                    this.detailData = res.response;
                    this.filterDetailData();
                }
            });
        },
        lookDocu(row) {
            this.itemId = row.Id;
            if (row.FileCount === 0) {
                this.$message({
                    message: '此项下暂无文档可查看!',
                    type: 'warning'
                });
                return;
            }
            if (this.IsInput != "") {
                this.IsEnableLookFile = false;
            }
            else {
                this.IsEnableLookFile = true;
            }
            if (this.fileManagermentFileId != null) {
                this.IsEnableLookFile = false;
            }
            //判断模块的状态是否是提交、审核通过
            if (row.SubmitState == 1 || row.SubmitState == 3) {
                this.IsEnableLookFile = false;
            }
            this.lookDocumentVisible = true;

        },
        check() {
            this.checkVisible = true;
            let parms = { Id: this.assessmentFile.Id };
            postSelectNotCheck(parms).then((res) => {
                if (res.success) {
                    this.notCheckData = res.response
                }
            })
        },
        checkDataChoose(id) {
            sessionStorage.setItem('checkId', id);
            this.loadAssessmentFile();
        },
        checkHandleClose(done) {
            done();
        },
        cellClick(row, column, cell, event) {
            if (this.IsInput != "") {
                let index = this.detailData.indexOf(row);
                this.IsShowText = false;
                if (this.assessmentFile.State == 4) {
                    this.$set(this.detailData[index], "$isScoreEdit", false);
                    this.$set(this.detailData[index], "$isRemarkEdit", false);
                }
                else {
                    this.$set(this.detailData[index], "$isScoreEdit", true);
                    this.$set(this.detailData[index], "$isRemarkEdit", true);
                }
            }
        },
        editScore(row) {
            let index = this.detailData.indexOf(row);
            this.$set(this.detailData[index], "$isScoreEdit", false);
        },
        editRemark(row) {
            let index = this.detailData.indexOf(row);
            this.$set(this.detailData[index], "$isRemarkEdit", false);
            console.log(row);
        },
        async build() {
            if (this.checkValue == "") {
                this.$message({
                    type: 'warning',
                    message: '请先新建考核'
                });
                return
            }
            if (this.assessmentFile.Id === "") {

                this.$confirm('此机构暂无考核档案，是否生成?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let loading = Loading.service({
                        lock: true,
                        text: '正在生成中...',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });
                    generateAssessment([this.hospitalId], this.checkValue).then((res) => {
                        console.log(res);
                        if (res.success == undefined && res) {
                            loading.close();
                            this.$message({
                                type: 'success',
                                message: '生成成功'
                            });
                            this.loadAssessmentFile();
                        }
                        else {
                            loading.close();
                            this.$message({
                                type: 'warning',
                                message: '生成失败' + res.msg
                            });
                        }
                    });

                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消生成'
                    });
                });
                return;
            }
            else
                await this.handleQuery()
        },
        //获取考核档案数据
        async loadAssessmentFile() {
            var parms = { hospitalId: this.hospitalId, chenckId: this.checkValue, fileId: this.fileManagermentFileId, state: this.fileValue };
            await getAssessmentFile(parms).then((res) => {
                this.assessmentFile = res.response;
                if (this.assessmentFile == null) {
                    this.$message({
                        message: '暂无考核档案,请先去生成考核档案',
                        type: 'warning'
                    });
                    this.tableData = [];
                    this.dataCount = 0;
                    this.assessmentFile = {
                        HospitalName: "",
                        Number: "",
                        Id: "",
                        State: "",
                        ScoreUserName: ""
                    };
                }
                else {
                    if (this.assessmentFile.State == 3 || this.assessmentFile.State == 4) {
                        this.assessmentFileState = this.assessmentFile.State;
                        this.reason = this.assessmentFile.Reason;
                    }
                    this.handleQuery()
                }
            });
        },
        uploadFile(row) {
            this.fileCount = 0;
            this.itemId = row.Id;
            this.myHeaders = { "Authorization": "Bearer " + this.$store.state.token };
            return document.querySelectorAll('input[name="file"]')[0].click();
        },
        //上传之前事件
        handleChange(file) {
            var sz = ["doc", "docx", "txt", "pdf", "xlsx", "xls"];
            var name = (file.name.substring(file.name.lastIndexOf('.') + 1)).toLowerCase();
            if (!sz.includes(name)) {
                this.$message({
                    message: '只能上传的文件格式为doc、docx、txt、pdf、xlsx、xls',
                    type: 'warning'
                });
                this.$refs.upload.clearFiles();
                return;
            }
            if (this.fileCount == 0) {
                this.fullscreenLoading = true;
                this.$refs.upload.submit();
            }
        },
        beforeupload(file) {
            this.fileCount = 1;
        },
        //文件上传事件
        uploadSuccess() {
            this.fullscreenLoading = false;
            this.$message({
                message: '上传成功',
                type: 'success'
            });
            console.log("弹出框2", this.fullscreenLoading);
            this.$refs.upload.clearFiles(); //去掉文件列表
            console.log(this.$refs.upload)
            this.loadDetailData();
        },
        uploadError() {
            this.fullscreenLoading = false;
            this.$message({
                message: '上传失败',
                type: 'warning'
            });
            this.$refs.upload.clearFiles(); //去掉文件列表
        },
        handleClickDetail(row) {
            this.editFormVisible = true;
            this.detailDataLoading = true;
            this.moduleId = row.Id;
            this.SubmitState = row.SubmitState;
            this.IsScoring = row.SubmitState == 0 || row.SubmitState == null || row.SubmitState == 2 ? false : true;
            getDetailItemPassMoudleId({ id: row.Id }).then((res) => {
                if (res.success) {
                    this.detailData = res.response;
                    this.filterDetailData();
                }
                this.detailDataLoading = false;
            });
        },
        deductReason(row) {
            console.log(row);
            this.deductReasonVisible = true;
            postSelectDeductReason({ moduleId: row.Id }).then((res) => {
                if (res.success) {
                    this.deductReasonData = res.response;
                }
            });
        },
        deductReasonHandleClose(done) {
            done();
            this.deductReasonData = [];
        },
        filterDetailData() {
            console.log(this.IsInput);
            for (let index = 0; index < this.detailData.length; index++) {
                this.$set(
                    this.detailData, index,
                    {
                        ...this.detailData[index],
                        isShowBtn: this.IsInput ? false : true
                    }
                )
            }
        },
        handleClose(done) {
            done();
            this.loadAssessmentFile();
        },
        handleCurrentChange(val) {
            this.pageIndex = val;
            this.handleQuery();
        },
        //获取列表
        async handleQuery() {
            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            let IsRatingAgency = true;
            if (this.IsInput != "") {
                IsRatingAgency = false;
            }
            if (this.fileValue != "") {
                IsRatingAgency = false;
            }
            let parms = { fileId: this.assessmentFile.Id, key: this.input, page: this.pageIndex, intPageSize: this.pageSize, IsRatingAgency: IsRatingAgency };
            await getEvaluationAgencyList(parms).then((res) => {
                this.total = res.response.dataCount;
                this.tableData = res.response.data;
                console.log(this.tableData, res);
            });
            loading.close();
        },
        spanMethod({ row, column, rowIndex, columnIndex }) {
            if (row.IsHb.indexOf(columnIndex) != -1 && row.ColSpan != row.RowSpan) {
                //当前索引存在数组里
                if (row.ColSpan > row.RowSpan) {
                    return [1, row.ColSpan];
                }
                else {
                    return [row.RowSpan, 1];
                }
            }
            else {
                if (row.ColSpan > row.RowSpan) {
                    //合并列
                    if (columnIndex >= row.IsHb[0] && columnIndex <= row.ColSpan) {
                        return [0, 0];
                    }
                }
                else {
                    if (row.IsHb.indexOf(columnIndex) != -1 && row.ColSpan === row.RowSpan && columnIndex === row.IsHb[columnIndex]) {
                        return [0, 0];
                    }
                    else {
                        return [1, 1];
                    }
                }
                return [1, 1];
            }
        },
        submit() {
            this.$confirm('是否提交?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                if (this.assessmentFile.State === "2") {
                    this.$message({
                        type: 'success',
                        message: '您已提交!'
                    });
                    return;
                }
                let parms = { id: this.assessmentFile.Id };
                GetUpdateStatus(parms).then((res) => {
                    if (res.success) {
                        this.loadAssessmentFile();
                        this.$message({
                            type: 'success',
                            message: '提交成功!'
                        });
                    }
                    else {
                        this.$message({
                            type: 'error',
                            message: '提交失败!'
                        });
                    }
                });
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消提交'
                });
            });
        },
        calculate(num) {
            if (!this.IsScoring) {
                this.$message({
                    message: '该考核模块未提交，考核机构不能打分以及操作保存数据功能！！！',
                    type: 'warning'
                });
                return;
            }
            if (num == 3) {
                this.$confirm('是否确定审核通过?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.auditData(num);
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消审核'
                    });
                });
            }
            else {
                this.auditData(num);
            }
        },
        auditData(num) {
            this.fullscreenLoading = true;
            let parms = {
                ItemDto: this.detailData,
                ModelId: this.moduleId,
                AssessmentFileId: this.assessmentFile.Id,
                SubmitState: num
            }
            postCalculateScore(parms).then((res) => {
                this.fullscreenLoading = false;
                if (res.success) {
                    this.$message({
                        message: '保存成功',
                        type: 'success'
                    });
                    if (num != null) {
                        this.SubmitState = num;
                    }
                }
                else {
                    this.$message({
                        message: '保存失败',
                        type: 'warning'
                    });
                }
            })
        }
    }
}
</script>


<style lang="less" scoped>
/* 设置显示隐藏部分内容，按50%显示 */
// .el-popper {
//     max-width: 50%;
// }
// .loading-overlay {
//   flex-direction: column;
//   position: fixed;
//   top: 0;
//   left: 0;
//   width: 100%;
//   height: 100%;
//   background-color: rgba(0, 0, 0, 0.7);
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   z-index: 9999;
// }
// ::v-deep .el-progress__text{
//   font-size: 12px !important;
//   color: rgb(30, 160, 225) !important;
// }
// ::v-deep .el-progress-circle{
//   width: 50px !important;
//   height: 50px !important;
// }
// .tips_css{
//   font-size: 12px;
//   color: rgb(30, 160, 225)
// }
::v-deep .el-icon-close:before {
    font-size: 30px !important;
}
</style>